import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Product.css';
import { IoMdAddCircle } from "react-icons/io";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ImageURL, mainImageURI, singleProductURL } from '../../components/assets/constants/Urls/Url';
import AddToCart from '../../hooks/addCart';
import { handleAddToCart } from '../../hooks/handleAddToCart';
import DOMPurify from 'dompurify';
import truncate from 'html-truncate';
import { Modal } from 'react-bootstrap';
import { useSwipeable } from 'react-swipeable';
import { AiFillCloseCircle } from "react-icons/ai";
import Card from '../../components/Card/Card';
import RelatedProducts from '../../hooks/relatedProduct';
import Reviews from '../../components/Reviews/Reviews'
import { FaStar } from 'react-icons/fa';
import { useTheme } from '../../components/assets/context/ThemeContex';

const Product = () => {
  const { id } = useParams();
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const navigate = useNavigate();
  const width = window.innerWidth;
  const isMobile = width && width < 576;

  const { theme } = useTheme();

  // Related products
  const { productData, error, isRelatedLoading } = RelatedProducts(id);
//console.log('product data:', productData)

  // Close the modal when the back button is pressed
  useEffect(() => {
    const handlePopState = () => {
      if (isFullScreen) {
        // Prevent the default back navigation and close the modal
        setIsFullScreen(false);
      } 
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isFullScreen]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${singleProductURL}${id}`);
        const imagesRes = await axios.get(`${ImageURL}${id}`);

        setProduct(response.data);
        if (imagesRes.data.images && imagesRes.data.images.length > 0) {
          setImages((imagesRes.data.images).sort());
          //console.log('images:',  (imagesRes.data.images))
          setSelectedImageIndex(0);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleMainImageClick = () => {
    setIsFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setIsFullScreen(false);
  };

  const handleSwipe = (direction) => {
    if (direction === 'LEFT') {
      setSelectedImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    } else if (direction === 'RIGHT') {
      setSelectedImageIndex((prevIndex) =>
        (prevIndex - 1 + images.length) % images.length
      );
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSwipe('LEFT'),
    onSwipedRight: () => handleSwipe('RIGHT'),
  });

  const handleBuyNow = () => {
    handleAddToCart({ product }).then(() => navigate('/checkout'));
  };

  const setQuantity_ = (sign) => {
    setQuantity((prevQuantity) => {
      if (sign === '+') {
        return prevQuantity + 1;
      } else if (sign === '-' && prevQuantity > 1) {
        return prevQuantity - 1;
      }
      return prevQuantity;
    });
  };

  const handleQuantityChange = (value) => {
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue) && parsedValue > 0) {
      setQuantity(parsedValue);
    } else if (value === '') {
      setQuantity('');
    }
  };

  const handleQuantityBlur = () => {
    if (quantity === '') {
      setQuantity(1);
    }
  };

  const truncatedDescription =
    showFullDescription && product && product.description
      ? product.description
      : product && product.description
      ? truncate(product.description, 100)
      : '';

      if (isLoading) {
        return (
          <div className="skeleton">
            <div className="skeleton-image"></div>
            <div className="skeleton-title"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-price"></div>
            <div className="skeleton-button"></div>
          </div>
        );
      }

  if (!product) {
    return <div>Product not found</div>;
  }

  

  return (
    <div className="container" style={{ background: "var(--background)", color: "var(--textMain)" }}>
      <div className="row">
        <div className="col-md-6">
          {/* <img
            src={`${mainImageURI}${images[selectedImageIndex]}/${product.id}`}
            className="img-fluid main-image"
            alt={product.name}
            onClick={handleMainImageClick}
            style={{ cursor: 'pointer' }}
          /> */}
          <picture> 
              <source srcSet={`${mainImageURI}${images[selectedImageIndex].replace(/\.(jpg|jpeg|png)$/, '.webp')}/${product.id}`} type="image/webp" />
              <img 
                src={`${mainImageURI}${images[selectedImageIndex]}/${product.id}`} 
                className="img-fluid main-image"
                alt={product.name}
                onClick={handleMainImageClick} 
                loading='lazy'
                style={{ cursor: 'pointer' }}
              />
              </picture>
          <div className="image-gallery mt-2">
            {images.map((image, index) => (
              <img
                key={index}
                src={`${mainImageURI}${image}/${product.id}`}
                className={`img-thumbnail gallery-image me-2 ${
                  selectedImageIndex === index ? 'active' : ''
                }`}
                alt={`Thumbnail ${index + 1}`}
                loading='lazy'
                onClick={() => setSelectedImageIndex(index)}
              />
            ))}
          </div>

          <Modal
            show={isFullScreen}
            onHide={handleCloseFullScreen}
            centered
            size="lg"
            dialogClassName="fullscreen-modal"
            backdrop="static"
            keyboard={false}
            className='mo'
          >
            <div {...swipeHandlers}>
              <Modal.Body className="p-0">
                <img
                  src={`${mainImageURI}${images[selectedImageIndex]}/${product.id}`}
                  className="w-100"
                  alt={product.name}
                />
                <button
                  className="close-gallery"
                  onClick={handleCloseFullScreen} 
                >
                  <AiFillCloseCircle color='red' size={30}/>
                </button>
              </Modal.Body>
            </div>
          </Modal>

        </div>
        <div className="col-md-6">
          <h2 className="fw-bold" style={{ color: "var(--textHeading)" }}>{product.name}</h2>


          {[...Array(5)].map((_, i) => (
            <FaStar
              key={i}
              color={i < product.average_rating ? theme.colors.primary : theme.colors.textMuted}
              size={24}
            />
          ))}

          {isMobile ? (
            <MobileQuantityAdjust
              quantity={quantity}
              setQuantity_={setQuantity_}
              price={product.price}
              theme={theme}
            />
          ) : (
            <DesktopQuantityAdjust
              quantity={quantity}
              handleQuantityChange={handleQuantityChange}
              handleQuantityBlur={handleQuantityBlur}
              price={product.price}
              theme={theme}
            />
          )}
          <div className="fixed-buttons-container">
            <AddToCart product={product} quantity={quantity} images={images} />
            <button
              className="btn buy"
              style={{
                background: "var(--primary)",
                color: "var(--background)",
                border: "none"
              }}
              onClick={handleBuyNow}
            >
              Buy Now
            </button>
          </div>
          {product && (
            <div
              className="product-description"
              style={{ color: "var(--textMain)" }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(truncatedDescription),
              }}
            />
          )}
          <button
            className="btn btn-link"
            style={{ color: "var(--link)" }}
            onClick={() => setShowFullDescription(!showFullDescription)}
          >
            {showFullDescription ? 'Show Less' : 'Read More'}
          </button>

          <Reviews productId={product.id} />
        </div>
        <hr />
        <h2 className="best-sellers-title" style={{marginTop:20,marginBottom:10}}>Similar Product</h2>
        {productData && productData.map((product) =>{
          return (<div
          className="col-6 col-md-4 col-lg-3"
          key={product.id}
          //ref={index === products.length - 1 ? lastProductRef : null}
          style={{ rowGap:'10px' }} 

        >
          <Card item={product} />
        </div>);
        })}
          {console.log('product', productData)}
      </div>
    </div>
  );
};

const MobileQuantityAdjust = ({ quantity, setQuantity_, price, theme }) => (
  <div className="price-quantity">
    <h4 className="price" style={{ color: "var(--primary)" }}>${price}</h4>
    <span className="quantity-span">
      <p className="adjust" onClick={() => setQuantity_('-')} >-</p>
      <p className="quantity-num">{quantity}</p>
      <p className="adjust" onClick={() => setQuantity_('+')} >+</p>
    </span>
  </div>
);

const DesktopQuantityAdjust = ({
  quantity,
  handleQuantityChange,
  handleQuantityBlur,
  price,
  theme
}) => (
  <>
    <h4 className="price" style={{ color: "var(--primary)" }}>${price}</h4>
    <div className="form-group mb-3 quantity">
      <label htmlFor="quantity">Quantity:</label>
      <input
        type="number"
        id="quantity"
        className="form-control"
        value={quantity}
        onChange={(e) => handleQuantityChange(e.target.value)}
        onBlur={handleQuantityBlur}
        min="1"
        style={{ background: "var(--cardBackground)", color: "var(--textMain)", borderColor: "var(--inputBorder)" }}
      />
    </div>
  </>
);

export default Product;
